<template>
  <div id=player class="player theoplayer-container video-js theoplayer-skin" ref=player></div>
</template>

<script>
  export default {
    data () {
      return {}
    },
    methods: {
      async init () {
        const element = document.querySelector('#player')
        const player = new THEOplayer.Player(element, {
          libraryLocation: './'
        })

        // const dash = 'http://storage.googleapis.com/planet-horror.appspot.com/asset/la-mansion-de-los-horrores/la-mansion-de-los-horrores.mpd'
        // const hls = 'http://localhost/la-mansion-de-los-horrores.m3u8'
        // const hls = 'http://storage.googleapis.com/planet-horror.appspot.com/asset/la-mansion-de-los-horrores/la-mansion-de-los-horrores.m3u8'
        const dash = 'http://cdn.theoplayer.com/video/elephants-dream/playlist.mpd'
        const hls = 'http://cdn.theoplayer.com/video/elephants-dream/playlist.m3u8'

        const keyOSDRMConfiguration = { 
          integration : 'keyos',
          widevine: {
            licenseAcquisitionURL: 'https://widevine-dash.ezdrm.com/proxy?pX=80BA2D'
          },
          playready: {
            licenseAcquisitionURL: 'https://playready.ezdrm.com/cency/preauth.aspx?pX=A8DC04'
          }
        }

        player.source = {
          sources: [{
            src: hls,
            type: 'application/x-mpegurl',
            keyOSDRMConfiguration
          }, {
            src: dash,
            type: 'application/dash+xml',
            keyOSDRMConfiguration
          }]
        }
      }
    },
    activated () {
      this.init()
    },
    deactivated () {

    }
  }
</script>
<style>
  .video-js {
    width: 100%;
    height: calc(100vh - 64px);
  }
</style>
